import { SHOW_MODAL } from '../actionTypes';
import { createContactModalActions } from '../reducer';

export default (isOpen) => createContactModalActions[SHOW_MODAL](isOpen);
